import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react'

import '../../assets/css/0020_objects/0810_obj_expertise_points_aside.css'

class ObjExpertisePointsAside extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
        const { datasExpertise } = this.props;

        return (<> {datasExpertise && <>
			<div className="obj_expertise_points_aside">
			 	<div className="obj_dashboard_infos">
			 		<h3 className="t_title"><strong>Mon Expertise</strong> {datasExpertise.Brand_Name} </h3>

			 		<div className="obj_progress-bar_formation">
			 			<h4 className="t_title"><strong>{datasExpertise.UserTrainingsOnLine_Completed} </strong>{datasExpertise.UserTrainingsOnLine_Completed>1 ? "Formations réalisées":"Formation réalisée"}</h4>

			 			<div className="obj_progress-bar">
			 				<div className="ctn_steps">
			 					{Array.from(Array(datasExpertise.Brand_NbTrainingsOnLine), (e, i) => {
			 						if (i < datasExpertise.UserTrainingsOnLine_Completed) {
			 							return <div key={i} className="step is-complete"></div>
			 						}
			 						return <div key={i} className="step"></div>
			 					})}
			 				</div>
			 			</div>
			 		</div>
			 	</div>
			</div>
        </>}</>)
    }
}

export default withTranslation()(withSitecoreContext()(ObjExpertisePointsAside));